/**
 * ST-5 — a phone that did not place the tag can still say something. One line
 * on the tag's own thread, with a name against it; no claim on the tag.
 */
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const bare = axios.create();

export default function TellTheOffice({ code, firm }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(() => {
    try {
      return (JSON.parse(window.localStorage.getItem('kmTagPlacer') || '{}') || {}).name || '';
    } catch {
      return '';
    }
  });
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [said, setSaid] = useState('');

  const send = async () => {
    if (!name.trim() || !text.trim()) {
      toast.error('Say who you are and what they should know');
      return;
    }
    setBusy(true);
    try {
      const { data } = await bare.post(`${API}/m/${code}/tell`,
        { name: name.trim(), text: text.trim() });
      setSaid(data.line || 'Thank you — the office has it.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'That did not go');
    } finally {
      setBusy(false);
    }
  };

  if (said) {
    return <div className="kfs-hold" data-testid="tag-tell-said">{said}</div>;
  }

  if (!open) {
    return (
      <div className="kfs-page__bd">
        <button type="button" className="kfs-btn kso-btn" onClick={() => setOpen(true)}
          data-testid="tag-tell-open">Tell the office</button>
      </div>
    );
  }

  return (
    <div className="kfs-page__bd" data-testid="tag-tell">
      <div className="kmt-form">
        <label style={{ gridColumn: '1 / -1' }}>Your name
          <input className="kso-in" maxLength={60} value={name}
            onChange={(e) => setName(e.target.value)} data-testid="tag-tell-name" />
        </label>
        <label style={{ gridColumn: '1 / -1' }}>
          What should {firm || 'the office'} know?
          <textarea className="kso-in" rows={3} maxLength={1000} value={text}
            onChange={(e) => setText(e.target.value)} data-testid="tag-tell-text" />
        </label>
      </div>
      <button type="button" className="kfs-btn kso-btn brand" disabled={busy}
        onClick={send} data-testid="tag-tell-send">
        {busy ? 'Sending…' : 'Send it'}
      </button>
    </div>
  );
}
